import { Button } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@altimateai/lego";
import { Badge } from "@altimateai/lego";
import { IconExternalLink } from "@tabler/icons-react";
import { EvalResult } from "../../services/evals";
import { TurnResultCard } from "./TurnResultCard";
import { getLangfuseTraceUrl } from "../utils";

interface ResultDetailModalProps {
  result: EvalResult;
  onClose: () => void;
  onDelete: () => void;
}

export const ResultDetailModal: React.FC<ResultDetailModalProps> = ({
  result,
  onClose,
  onDelete,
}) => {
  console.log("[ResultDetailModal] Rendering with result:", {
    id: result.id,
    test_case_name: result.test_case_name,
    overall_score: result.overall_score,
    turn_results_type: typeof result.turn_results,
    turn_results_is_array: Array.isArray(result.turn_results),
    turn_results_length: result.turn_results?.length,
  });
  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="al-max-w-screen-xl al-max-h-[90vh] al-overflow-y-auto">
        <div>
          <DialogHeader>
            <DialogTitle>{result.test_case_name}</DialogTitle>
            <Stack direction="row" align="center" gap="md" className="al-mt-1">
              {result.run_name && (
                <div className="al-text-sm al-text-gray-600">
                  Run:{" "}
                  <Badge
                    variant="secondary"
                    className="al-ml-1 al-bg-purple-100 al-text-purple-700 al-border-purple-200"
                  >
                    {result.run_name}
                  </Badge>
                </div>
              )}
              {result.trace_id && (
                <a
                  href={getLangfuseTraceUrl(result.trace_id)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="al-inline-flex al-items-center al-gap-1 al-text-sm al-text-blue-600 hover:al-text-blue-800 hover:al-underline"
                >
                  <IconExternalLink className="al-w-4 al-h-4" />
                  View Trace in Langfuse
                </a>
              )}
            </Stack>
            <Stack direction="row" align="center" gap="lg" className="al-mt-2">
              <div className="al-text-sm al-text-gray-600">Overall Score:</div>
              <div className="al-pointer-events-none">
                <Badge
                  variant={
                    result.overall_score >= 4
                      ? "default"
                      : result.overall_score >= 3
                        ? "secondary"
                        : "destructive"
                  }
                  className={
                    result.overall_score >= 4
                      ? "al-bg-green-500 al-text-white hover:al-bg-green-600 al-text-base"
                      : "al-text-base"
                  }
                >
                  {Math.round(result.overall_score)}/5
                </Badge>
              </div>
              <div className="al-pointer-events-none">
                <Badge
                  variant={
                    result.overall_score >= 4
                      ? "default"
                      : result.overall_score >= 3
                        ? "secondary"
                        : "destructive"
                  }
                  className={
                    result.overall_score >= 4
                      ? "al-bg-green-500 al-text-white hover:al-bg-green-600"
                      : ""
                  }
                >
                  {result.overall_score >= 4 ? "Pass" : result.overall_score >= 3 ? "Ok" : "Fail"}
                </Badge>
              </div>
            </Stack>
          </DialogHeader>
        </div>

        <Stack direction="column" gap="md">
          {result.turn_results?.map((turn, index) => (
            <TurnResultCard key={index} turn={turn} variant="detailed" />
          ))}
        </Stack>
        <div>
          <DialogFooter className="al-mt-4">
            <Button
              onClick={onDelete}
              variant="outline"
              size="sm"
              className="al-text-red-600 hover:al-text-red-700 hover:al-bg-red-50 al-border-red-200"
            >
              Delete
            </Button>
            <div className="al-flex-1" />
            <Button onClick={onClose} variant="outline" size="sm">
              Close
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
};
